export default __webpack_public_path__ + "static/media/anp-project.eac3e3da.jpeg";